import { useState, useEffect, useRef } from 'react';
import { SignInButton } from '@clerk/clerk-react';
import { Button } from '../input';
import { useGlobal } from '../../state';

export const FFSignInWrapper = ({ children, ...props }) => {
  const { user } = useGlobal();

  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  if (user) {
    return children;
  }

  return (
    <SignInButton
      mode="modal"
      signUpFallbackRedirectUrl={props.signUpFallbackRedirectUrl || currentUrl}
      signInFallbackRedirectUrl={props.signInFallbackRedirectUrl || currentUrl}
      fallbackRedirectUrl={props.fallbackRedirectUrl || currentUrl}
    >
      {children}
    </SignInButton>
  );
};

export const FFSignInButton = ({ children, ...props }) => {
  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  return (
    <SignInButton
      mode="modal"
      signUpFallbackRedirectUrl={props.signUpFallbackRedirectUrl || currentUrl}
      signInFallbackRedirectUrl={props.signInFallbackRedirectUrl || currentUrl}
      fallbackRedirectUrl={props.fallbackRedirectUrl || currentUrl}
    >
      <Button large style={{ width: '100%' }} {...props}>
        {children || 'Sign In'}
      </Button>
    </SignInButton>
  );
};
